// extracted by mini-css-extract-plugin
export default {"topSection":"styles_topSection__vCI6O","saveButton":"styles_saveButton__Mt0Pl","switcherContainer":"styles_switcherContainer__5Vbqe"};